/**
 * Default subscription ID for the user sign up flow.
 * Used for Grow 4-50 locations.
 */
export const BASE_FLOW_SUBSCRIPTION_ID = '257';

/**
 * Subscription ID for the Simply Listings plan.
 * Used when the sign up flow should assign the Simply Listings product.
 */
export const SIMPLY_LISTINGS_SUBSCRIPTION_ID = '290';

/** Package ID for the current Simply Listings plan. */
export const SIMPLY_LISTINGS_PACKAGE_ID = 'simply-listings';

/**
 * Package IDs that belong to the Simply Listings / CB-only package group.
 * Includes the legacy `'cb'` package ID for backwards compatibility.
 */
export const SIMPLY_LISTINGS_PACKAGE_IDS = ['cb', 'cb-only', SIMPLY_LISTINGS_PACKAGE_ID] as const;

/** A package ID that belongs to the Simply Listings / CB-only package group. */
export type SimplyListingsPackageId = (typeof SIMPLY_LISTINGS_PACKAGE_IDS)[number];

/** Package ID for the Track plan. */
export const TRACK_PACKAGE_ID = 'track';

/** Package ID for the Manage plan. */
export const MANAGE_PACKAGE_ID = 'manage';

/** Package ID for the Grow plan. */
export const GROW_PACKAGE_ID = 'grow';

/** Package ID for the Custom plan. */
export const CUSTOM_PACKAGE_ID = '';
